// Utilities to build stable, human-readable context keys for the Image Manager
// - Keys isolate selection state per caller (scope/field/entity)
// - When an entity id is missing (draft), a draftId is persisted in localStorage

function safeWindowPathname() {
  try {
    if (typeof window !== "undefined" && window.location?.pathname) {
      return window.location.pathname;
    }
  } catch {}
  return "";
}

export function getOrCreateDraftId({ scope = "global", field = "default", routeKey } = {}) {
  const route = routeKey ?? safeWindowPathname();
  const storageKey = `imgmgr:draft:${scope}:${field}:${route}`;
  try {
    const existing = localStorage.getItem(storageKey);
    if (existing) return existing;
    const id = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now());
    localStorage.setItem(storageKey, id);
    return id;
  } catch {
    // Fallback to ephemeral id (won't persist across refresh)
    return (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now());
  }
}

export function buildImageContextKey({ scope, field, entityId, routeKey, tenantId } = {}) {
  const prefix = tenantId ? `tenant:${tenantId}:` : "";
  const fieldSeg = field ? `:${field}` : "";

  if (entityId) {
    return `${prefix}${scope}:${entityId}${fieldSeg}`;
  }

  const draftId = getOrCreateDraftId({ scope, field, routeKey });
  return `${prefix}${scope}:draft:${draftId}${fieldSeg}`;
}

